import { Injectable } from '@angular/core';
import { ModulesType } from './modules-type';
import { Role } from './role';

@Injectable()
export class RoleModuleMappingService {
    constructor() { }

    RoleToModuleMapper: any[] = [
        {
            roleName: Role.MASTERADMIN,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
                ModulesType.DIAGNOSTICS,
            ]
        },
        {
            roleName: Role.CUSTOMERADMIN,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.UNITADMIN,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.COO,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.CMO,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.UNITHEAD,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.MINECELLHO,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.FH,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.DHMINEOPERATION,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.MINEINSIGHTS,
                ModulesType.PLANNING,
                ModulesType.OPERATIONCONTROL,
                ModulesType.MAINTENANCE,
                ModulesType.DRILLBLAST,
                ModulesType.GRADECONTROL,
                ModulesType.MINEOPTIMIZATION,
                ModulesType.OVERVIEW,
                ModulesType.SAP,
            ]
        },
        {
            roleName: Role.PLANNINGENGINEER,
            modules: [
                ModulesType.CONFIGURATION,
                ModulesType.PLANNING,
                ModulesType.OVERVIEW,
            ]
        },
        {
            roleName: Role.DRILLBLASTENGINEER,
            modules: [
                ModulesType.DRILLBLAST,
                ModulesType.OVERVIEW,
            ]
        },
        {
            roleName: Role.MINEOPERATIONENGINEER,
            modules: [
                ModulesType.OPERATIONCONTROL,
                ModulesType.OVERVIEW,
            ]
        },
        {
            roleName: Role.QCANALYSIS,
            modules: [
                ModulesType.GRADECONTROL,
                ModulesType.OVERVIEW,
            ]
        },
        {
            roleName: Role.DHMINEMAINTENANCE,
            modules: [
                ModulesType.MAINTENANCE,
                ModulesType.OVERVIEW,
            ]
        },
        {
            roleName: Role.MAINTENANCEENGINEER,
            modules: [
                ModulesType.MAINTENANCE,
                ModulesType.OVERVIEW,
            ]
        },
        {
            roleName: Role.UNKNOWN,
            modules: [ModulesType.OVERVIEW]
        }
    ];
    moduleType: any[] = [
        {
            key: 1,
            value: ModulesType.OVERVIEW
        },
        {
            key: 2,
            value: ModulesType.MINEINSIGHTS
        },
        {
            key: 3,
            value: ModulesType.PLANNING
        },
        {
            key: 4,
            value: ModulesType.OPERATIONCONTROL
        },
        {
            key: 5,
            value: ModulesType.MAINTENANCE
        },
        {
            key: 6,
            value: ModulesType.DRILLBLAST
        },
        {
            key: 7,
            value: ModulesType.GRADECONTROL
        },
        {
            key: 8,
            value: ModulesType.MINEOPTIMIZATION
        },
        {
            key: 9,
            value: ModulesType.SAP
        },
        {
            key: 10,
            value: ModulesType.PRODUCTCONFIG
        },
        {
            key: 11,
            value: ModulesType.CONFIGURATION
        },
        {
            key: 12,
            value: ModulesType.DIAGNOSTICS
        }
    ];

    GetModulesByRole(role: any) {
        return this.RoleToModuleMapper.find(a => a.roleName == role).modules;
    }

    GetRolesByModule(moduleName: any) {
        return this.RoleToModuleMapper.filter(a => a.modules.some(a => a == moduleName)).map(b => b.roleName);
    }
    GetLeftModules(selecedKey: number) {       
       return this.moduleType.find(e => e.key == selecedKey).value;
    }
}